<template>
    <div>
        <div v-if="hasProfilePermissions">
            <!-- Edit API Token -->
            <template v-if="singleView">
                <sau-api-token :token="selected" v-on:cancel="updateDataTable"></sau-api-token>
            </template>

            <template v-else>
                <!-- Info Block -->
                <div class="row mb-6" v-if="!userFeatures.hasOwnProperty('api-token-introduction')">
                    <div class="col">
                        <div class="d-flex align-items-center sau-bx p-4">
                            <i class="fal fa-info-circle pr-2 sm primary"></i>
                            <div class="sau-para-last">
                                <p>
                                    The MySAU API provides all the necessary endpoints such as ordering, managing server products, invoicing and ticketing.
                                    Find out more by viewing our
                                    <a
                                        href="https://dev-api.mysau.com.au/v2/#/Dedicated_Servers"
                                        target="_blank"
                                    >API docs.</a>
                                </p>
                            </div>
                        </div>
                        <a
                            href="#"
                            class="sau-font xs float-right sau-linx gray"
                            @click.prevent="hideInfo('api-token-introduction')"
                        >Don't show this again</a>
                    </div>
                </div>
                <div class="row">
                    <div class="col mb-4 pb-4">
                        <a
                            href="#"
                            @click.prevent="createToken()"
                            class="btn btn-primary float-lg-right"
                        >
                            <i class="fas fa-plus"></i> Create a new API Token
                        </a>
                    </div>
                </div>

                <sau-template :retrieved="gotData">
                    <!-- Fetching Placeholder -->
                    <template slot="message">Fetching Api Tokens</template>
                    <!-- Data -->
                    <template slot="data">
                        <table
                            v-if="apiTokens.length"
                            id="data-table-apitokens"
                            class="table table-hover data-table"
                            data-search="Search"
                            cellspacing="0"
                            width="100%"
                        >
                            <!-- 1 column layout like services / domains -->
                            <thead class="d-none">
                                <tr>
                                    <th>Details</th>
                                    <th class="noshow">Status</th>
                                    <th class="noshow">API Token</th>
                                    <th class="noshow">Comments</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="apiToken in apiTokens" :key="apiToken.id">
                                    <td>
                                        <a href="#" @click.prevent="editToken(apiToken)">
                                            <div class="d-flex product-list">
                                                <div class="text-center p-2">
                                                    <i
                                                        class="product-icons pr-6 pt-2 fal fa-key my-4"
                                                        aria-hidden="true"
                                                    ></i>
                                                </div>
                                                <div class="p-2">
                                                    <p class="product-name">{{ apiToken.token }}</p>
                                                    <p class="product-desc">
                                                        <span
                                                            class="sau-font-bold"
                                                        >{{ createTooltip(apiToken.enabled) }}</span>
                                                        <span
                                                            class="sau-dot xs"
                                                            :class="getStatus(apiToken.enabled)"
                                                            v-b-tooltip.hover
                                                            :title="createTooltip(apiToken.enabled)"
                                                        ></span>
                                                    </p>
                                                    <p class="product-desc">
                                                        <span class="sau-font-bold">Allowed IPS:</span>
                                                        <span>{{ formatArray(apiToken.allowedips) }}</span>
                                                    </p>
                                                    <p class="product-desc">
                                                        <span class="sau-font-bold">Permissions:</span>
                                                        <span>{{ formatArray(apiToken.permissions) }}</span>
                                                    </p>
                                                    <p class="product-desc">
                                                        <span class="sau-font-bold">Comments:</span>
                                                        <span>{{ apiToken.tokenComment }}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </a>
                                    </td>
                                    <td :data-filter="applyFilter('status', apiToken.enabled)">
                                        <span
                                            class="sau-dot xs"
                                            :class="getStatus(apiToken.enabled)"
                                            v-b-tooltip.hover
                                            :title="createTooltip(apiToken.enabled)"
                                        ></span>
                                    </td>
                                    <td
                                        :data-filter="applyFilter('token', apiToken.token)"
                                    >{{apiToken.token}}</td>
                                    <td
                                        :data-filter="applyFilter('comment', apiToken.tokenComment)"
                                    >{{apiToken.tokenComment}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else>
                            <sau-apiro-response type="message">
                                <template
                                    slot="message"
                                >You don't have any API Tokens at the moment.</template>
                            </sau-apiro-response>
                        </div>
                    </template>
                </sau-template>
            </template>
        </div>
        <div class="row" v-if="!hasProfilePermissions">
            <sau-request-permission></sau-request-permission>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ApiToken from './_ApiToken';
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    components: {
        'sau-api-token': ApiToken
    },
    mounted() {
        this.hasProfilePermissions = this.userDetails.whmcs_contact_id
            ? this.userDetails.permissions.split(',').indexOf('profile') > -1
            : true;
        if (this.hasProfilePermissions) {
            this.startApp();
        }
    },
    data() {
        return {
            singleView: false,
            selected: '',
            hasProfilePermissions: false,
            apiTokens: []
        };
    },
    methods: {
        startApp() {
            this.getApiTokens().then(response => {
                this.apiTokens = response.data;
                this.$nextTick(() => {
                    this.initializeDataTables();
                });
            });
        },
        getStatus(status) {
            switch (status) {
                case 'T':
                    return 'success';
                    break;
                case 'F':
                    return 'danger';
                    break;
                default:
                    return 'warning';
                    break;
            }
        },
        createTooltip(status) {
            switch (status) {
                case 'T':
                    return 'Enabled';
                    break;
                case 'F':
                    return 'Disabled';
                    break;
                default:
                    return 'Unknown';
                    break;
            }
        },
        createToken() {
            this.selected = '';
            this.singleView = true;
        },
        editToken(token) {
            this.selected = token;
            this.singleView = true;
        },
        formatArray(array) {
            let parsed =
                typeof array == 'string'
                    ? Object.values(JSON.parse(array))
                    : array;
            return parsed.length == 0 ? 'Not Set' : parsed.join(', ');
        },
        updateDataTable() {
            this.gotData = false;
            this.$nextTick(() => {
                this.gotData = true;
                this.initializeDataTables();
            });
        }
    }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
#data-table-apitokens a {
    color: #666;
    text-decoration: none;
}
</style>
